<template>

<div>
<v-form
   ref="form"
   v-model="valid"
   @submit.prevent="submit"
>
<v-container fluid class="mb-5">
    <v-row justify="space-between">
      <v-col cols="12" class="text-left">

        <template v-if="is_new">
            <v-btn color="" class="mr-5" @click="$router.go(-1)">
                戻る</v-btn>
            <v-btn color="mygreen" class="white--text" @click="touroku">
                登録</v-btn>
        </template>
        <template v-else>
            <v-btn color="" class="mr-5" @click="$router.go(-1)">
                戻る</v-btn>
            <v-btn type="submit" color="mygreen" class="white--text mr-5"
                        :disabled="delete_only"
            >
                更新</v-btn>
            <v-btn color="red" class="white--text" @click="deleteItem">
                削除</v-btn>
        </template>

      </v-col>
    </v-row>
  </v-container>

  <v-card class="pa-4 pb-10 mycard">
    <v-container fluid class="myform">

        <v-row>
            <v-col  cols="3" class="text-left">
              <h3 class="">{{ is_new ? 'メール登録' : 'メール編集' }}</h3>
            </v-col>
            <v-col  cols="2" class="text-left">
                <DialogPatientSearchMail></DialogPatientSearchMail>
            </v-col>
            <v-col cols="4" class="text-left">
              <span class="">※患者名は患者検索から入力してください。</span>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>患者名(漢字)</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field v-model="data.sei" 
                    :disabled="delete_only"
                    label="姓" outlined :rules="[v => !!v || '必須項目です.']" readonly class="gray"></v-text-field>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field v-model="data.mei"
                    :disabled="delete_only"
                    label="名" outlined :rules="[v => !!v || '必須項目です.']" readonly class="gray"></v-text-field>
            </v-col>
          <v-col cols="5"> </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>患者名(カナ)</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field
                v-model="data.sei_kana"
                :disabled="delete_only"
                label="セイ"
                :rules="[v => !!v || '必須項目です.']"
                outlined readonly class="gray"></v-text-field>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field
                v-model="data.mei_kana"
                :disabled="delete_only"
                label="メイ"
                :rules="[v => !!v || '必須項目です.']"
                outlined readonly class="gray"></v-text-field>
            </v-col>
        </v-row>



        <v-row>
          <v-col cols="2" class="text-left" align-self="center">
              <div>メールアドレス</div>
          </v-col>
          <v-col cols="1" align-self="center">
              <v-chip label outlined color="red">必須</v-chip>
          </v-col>
          <v-col cols="4" class="pt-11">
              <v-text-field
              v-model="data.mail"
              color="rgba(0, 189, 242, 1)"
              :disabled="delete_only"
              label="メールアドレス"
              :rules="[v => !!v || '必須項目です.']"
              outlined></v-text-field>
          </v-col>
          <v-col cols="6"> </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" class="text-left" align-self="center">
              <div>テンプレート名</div>
          </v-col>
          <v-col cols="1" align-self="center">
              <v-chip label outlined color="red">必須</v-chip>
          </v-col>
          <v-col cols="4" class="pt-11">

              <v-select dense
                  v-model="template_selected"
                  :items="templates"
                  :disabled="delete_only"
                  outlined
                  placeholder="選択してください"
                  :rules="[v => !!v || '必須項目です.']"
                  class="gray"
              ></v-select>

          </v-col>
          <v-col cols="6"> </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" class="text-left" align-self="center">
              <div>送信ステータス</div>
          </v-col>
          <v-col cols="1" align-self="center"> </v-col>
          <v-col cols="4" class="pt-11">
              <v-text-field
              v-model="data.status"
              color="rgba(0, 189, 242, 1)"
              :disabled="mystatus()"
              label="送信ステータス"
              outlined
              readonly
              class="gray"
              ></v-text-field>
          </v-col>
          <v-col cols="6"> </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>送信日時</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="5" align-self="end" class="pt-11">
                <v-row >
                    <!-- 日付選択 -->
                    <v-col cols="6" class="pr-0">
                        <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto" >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="data.send_date"
                            :disabled="delete_only"
                            append-icon="mdi-calendar-month"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            :rules="[v => !!v || '必須項目です.']"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="data.send_date"
                            @input="menu1 = false"
                            color="green lighten-1"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"
                        ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="5" class="">
                        <v-select dense
                            v-model="data.send_time"
                            :items="li_created"
                            :disabled="delete_only"
                            outlined
                            placeholder="選択してください"
                             :rules="[v => !!v || '必須項目です.']"
                            append-icon="mdi-clock-time-four-outline"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>



    </v-container>
  </v-card>
</v-form>


<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      timeout="3000"
      vertical
      top
      right
      outlined
    >
      <div v-html="snackbar_text"></div>
      <template v-slot:action="{  }">
        <img @click="snackbar = false" class="img" src="/img/x.svg" style="cursor:pointer;" />
      </template>
    </v-snackbar>
  </div>
</template>

</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
import DialogPatientSearchMail from '@/components/DialogPatientSearchMail.vue';
/* eslint-disable */


  export default {
    components:{
        DialogPatientSearchMail
    },

    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },

    // datas
    data(){
        return {
          // for snackbar

          is_new: false,
          param: 'new',
          patient_id: 0,
          templates: ['DM'],
          template_selected:'DM',
          menu1: false,
          delete_only: false,
          reserve_id: null,
          dialogDelete: false,
          title: '',
          snackbar: false,
          snackbar_text: '登録完了しました',
          valid: false,

          data:{
              from:'',
              to: '',
              status: '',
              created:'',
              create_date:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
              create_time:'',
              datetime:'',
              send_date:'',
              send_time:'',
              name: '',
              sei: '',
              mei: '',
              sei_kana: '',
              mei_kana: '',
              mail: '',
              patient_id: '',
              template: 'DM',
          },

          li_created: [
            ''
            ,'09:00'
            , '09:30'
            , '10:00'
            , '10:30'
            , '11:00'
            , '11:30'
            , '12:00'
            , '12:30'
            , '13:00'
            , '13:30'
            , '14:00'
            , '14:30'
            , '15:00'
            , '15:30'
            , '16:00'
            , '16:30'
            , '17:00'
            , '17:30'
            , '18:00'
            , '18:30'
            , '19:00'],
          start_selected: '',

        }

    },  // datas

    created () {
        console.log('%c created: MailDetail.vue', mycolor.created);
        console.log(this.$route);

        if(this.$route.name==='mail_detail_new'){
            this.is_new = true;

              let patient_id = this.$route.params.patient_id;

            if(patient_id){
                this.patient_id = patient_id;
                console.log('patient_id', mycolor.orange);
                console.log('patient_id: ', this.patient_id);

                // 患者情報取得して反映
                axios.get('/get_patient/'+this.patient_id)
                  .then((res) => {
                    console.group();
                    console.log('%c /get_patient/'+this.patient_id, mycolor.api);
                    console.log(res.data);
                    console.groupEnd();


                    this.bangou = res.data.bangou;
                    this.data.mei = res.data.mei;
                    this.data.mei_kana = res.data.mei_kana;
                    this.data.sei = res.data.sei;
                    this.data.sei_kana = res.data.sei_kana;
                    this.data.sei_kana = res.data.sei_kana;
                    this.data.mail = res.data.mail;
                    this.data.patient_id = res.data.patient_id

                    this.snackbar = true;
                    this.snackbar_text = `${res.data.sei} ${res.data.mei} 様の情報を反映しました。`;

                  })
                  .catch(() => {
                      console.error();
                  });
            }

        }else{
            this.is_new = false;
            this.getMail();
        }

    },  // created

    methods: {


          getMail () {

              console.log('========== getMail ==========');
              console.log('$route.params.name: ', this.$route.params.name);

              var api = '/get_mail/' +this.$route.params.name;
              axios.get(api)
                .then((res) => {

                    console.group();
                    console.log(`%c${api}`, mycolor.api);
                    console.log(res.data);
                    console.groupEnd();


                    if(res.data==='not found'){
                        alert('メールが見つかりません.');
                        return false;
                    }

                    if(res.data.template==='yoyaku_mail'){
                        this.delete_only = true;
                        this.li_created.push(res.data.create_time);
                    }

                    this.template_selected = res.data.template;
                    this.data.from = res.data.from;
                    this.data.status = res.data.status;
                    this.data.honbun = res.data.honbun;
                    this.data.created = res.data.created;
                    this.data.datetime = res.data.datetime;
                    this.data.name = res.data.name;
                    this.data.sei = res.data.sei;
                    this.data.mei = res.data.mei;
                    this.data.sei_kana = res.data.sei_kana;
                    this.data.mei_kana = res.data.mei_kana;
                    this.data.mail = res.data.mail;
                    this.data.send_date = res.data.send_date;
                    this.data.send_time = res.data.send_time;
                    this.data.create_date = res.data.create_date;
                    this.data.create_time = res.data.create_time;
                    console.log(this.data);
                    console.log(this.li_created);
                })
                .catch(() => {
                  // eslint-disable-next-line
                  console.error();

                });

            },  // getMail()

      submit(){
        console.group();
        console.log('submit()');
        console.log('%cthis.data', mycolor.purple);
        console.log(this.data);
        console.groupEnd();

        // 送信予約以外のステータスチェック
        if(this.data.status !== '送信予約') {
          alert('送信予約以外のものは編集できません');
          return false;
        }

        this.valid = this.$refs.form.validate();
        if(!this.valid){
          alert('未入力の必須項目があります.');
          return false;
        }

        this.data['yoyaku_date'] = this.data.send_date + ' ' + this.data.send_time;
        this.data['id'] = this.$route.params.name;

        axios.post('/upadte_mail', this.data)
            .then((res) => {
              console.group();
              console.log('/insert_mail', mycolor.api);
              console.log(res.data);
              console.groupEnd();
              this.$router.push('/mail').catch(()=>{});
            })
            .catch(() => {
              alert("登録できませんでした");
              console.error();
              return false;
            });
      }, // submit()


        touroku(){
            console.log('touroku()');

            this.valid = this.$refs.form.validate();
            if(!this.valid){
                alert('未入力の必須項目があります.');
                return false;
            }


            // mailにインサート
            this.data['template'] = this.template_selected;
            this.data['yoyaku_date'] = this.data.send_date + ' ' + this.data.send_time;


            console.log(this.data);
            axios.post( '/insert_mail', this.data )
              .then((res) => {
                console.group();
                console.log('/insert_mail', mycolor.api);
                console.log(res.data);
                console.groupEnd();
                this.$router.push('/mail').catch(()=>{});

              })
              .catch(() => {
                alert("登録できませんでした");
                console.error();
                return false;
              });


        },



        deleteItem(){
            console.log('deleteItem()');


            var api = this.$fastapi+'/delete_mail/' +this.$route.params.name;
            axios.get(api)
              .then((res) => {
                console.log(`%c${api}`, mycolor.orange);
                console.log(res.data);

                this.$router.push('/mail').catch(()=>{});

                return false;

              })
              .catch(() => {
                  console.error('');
              });


        }, // deleteItem()

        mystatus(){
            if(this.delete_only){
                return true;
            }

            if(this.is_new){
                this.data.status='送信予約';
                return true;
            }

            return false;
        },

    },  // methods

  }


</script>


<style scoped>
.mycard{
  height: 1384px;
}
.myform .row{
  max-height: 100px;
}
/*
.container{
  border: 1px solid green;
}
.row{
  border: 1px solid red;
}
.col{
  border: 1px solid blue;
}
*/
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ fieldset{
    background: #fff;
}
/deep/ .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: 48px;
}
/deep/ .v-text-field.v-textarea:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: unset !important;
}
/deep/ .gray .v-input__slot fieldset{
    background:#F0F0F0 !important;
}
/deep/ .gray .v-input__slot{
    background:#F0F0F0 !important;
}
/deep/ .row + .row{
    margin-top: 0px;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .v-text-field .v-label{
    line-height: 14px !important;
}
/deep/ .btn_group > div{
    display: inline-block;
    width: 124px;
    margin-right: 18px;
}
/deep/ .btn_group button{
    width: 124px;
}
/deep/ .theme--dark.v-btn.v-btn--disabled{
    background: #607d8b !important;
    color: #fff !important;
    cursor: not-allowed !important;
    pointer-events: unset;
}

/deep/ .v-snack--vertical .v-snack__wrapper{
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    margin-top: 84px;
    min-width: unset;
    padding: 0 20px;
}
/deep/ .v-snack__content{
    padding: 0px !important;
    margin-right: 30px;
}
/deep/ .v-snack--vertical .v-snack__wrapper .v-snack__action{
    margin: 0 !important;
    align-self: unset !important;
}
/deep/ .v-snack:not(.v-snack--has-background) .v-snack__wrapper{
    border: none !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

</style>
